import { notifyError, useNotifications } from 'Logic/Notifications.js'
import useListItemDataOnActionInstall from './useListItemDataOnActionInstall.js'

export default function useListItemDataOnSubmit(props, data) {
  let onActionInstall = useListItemDataOnActionInstall(props, data)

  let [, notify] = useNotifications()

  return async function onSubmit({ value, args, change }) {
    switch (args.type) {
      case 'install': {
        return await onActionInstall({ value, args, change })
      }

      default: {
        return notify(notifyError('Invalid action'))
      }
    }
  }
}
